export function LinkIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_2143_5128)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.61602 3.16387C2.96293 2.81696 3.43344 2.62207 3.92404 2.62207H6.92085C7.31525 2.62207 7.63497 2.94179 7.63497 3.33619C7.63497 3.73059 7.31525 4.05031 6.92085 4.05031H3.92404C3.81223 4.05031 3.705 4.09473 3.62594 4.17379C3.54688 4.25285 3.50246 4.36008 3.50246 4.47189V12.4218C3.50246 12.5336 3.54688 12.6409 3.62594 12.7199C3.705 12.799 3.81223 12.8434 3.92404 12.8434H11.874C11.9858 12.8434 12.093 12.799 12.1721 12.7199C12.2511 12.6409 12.2955 12.5336 12.2955 12.4218V9.16244C12.2955 8.76805 12.6153 8.44832 13.0097 8.44832C13.4041 8.44832 13.7238 8.76805 13.7238 9.16244V12.4218C13.7238 12.9124 13.5289 13.3829 13.182 13.7298C12.8351 14.0767 12.3646 14.2716 11.874 14.2716H3.92404C3.43344 14.2716 2.96293 14.0767 2.61602 13.7298C2.26911 13.3829 2.07422 12.9124 2.07422 12.4218V4.47189C2.07422 3.98129 2.26911 3.51078 2.61602 3.16387Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.36743 1.93238C8.36743 1.53718 8.68781 1.2168 9.08301 1.2168H14.3571V6.70854C14.3571 7.10375 14.0367 7.42413 13.6415 7.42413C13.2463 7.42413 12.9259 7.10375 12.9259 6.70854V3.7643L7.50929 9.63969C7.24141 9.93026 6.7887 9.94865 6.49813 9.68077C6.20756 9.41289 6.18917 8.96018 6.45705 8.66961L12.0085 2.64797H9.08301C8.68781 2.64797 8.36743 2.32759 8.36743 1.93238Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_2143_5128">
                    <rect width="14.3118" height="15.0273" fill="white" transform="translate(0.792969 0.389648)" />
                </clipPath>
            </defs>
        </svg>
    );
}
